var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ims-box"},[(_vm.slotExists('left'))?_c('div',{staticClass:"box-left"},[_vm._t("left")],2):_vm._e(),_vm._t("default"),(_vm.slotExists('right'))?_c('div',{staticClass:"box-right"},[_vm._t("right")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }